import cn from "classnames"
import { Fragment } from "react"

import { Flex, Text } from "@/atoms"
import { InformationPopover } from "@/molecules/InformationPopover"
import { ShowMore } from "@/molecules/ShowMore"

import styles from "./RepositoryTopics.module.scss"

import type { RepositoryTopicsProps } from "."

export const RepositoryTopics = (props: RepositoryTopicsProps) => {
  const { topics, empty } = props

  if (!topics?.length) return empty?.text || null

  const { t, classes = {}, placement = "topRight", maxCount = 5 } = props

  const topicsLength = topics.length
  const count = topicsLength > maxCount ? topicsLength - maxCount : 0
  const labels = topics.slice(0, maxCount)
  const labelsMaxIndex = labels.length - 1

  return (
    <Flex
      gap={4}
      align="center"
      className={cn(styles.minWidth, classes.container)}
    >
      <div className={styles.wrapper}>
        {labels.map((topic, index) => (
          <Fragment key={index}>
            <span className={styles.text}>{topic}</span>
            {index < labelsMaxIndex && (
              <span className={styles.divider}>|</span>
            )}
          </Fragment>
        ))}
      </div>

      {count > 0 && (
        <InformationPopover.Popover
          placement={placement}
          content={
            <InformationPopover.CommonTemplate
              title={t("general.repositoryTopics", { count })}
              classes={{ content: styles.popover }}
            >
              <Flex vertical gap={12}>
                {topics.slice(maxCount).map((topic, index) => (
                  <Text key={index}>{topic}</Text>
                ))}
              </Flex>
            </InformationPopover.CommonTemplate>
          }
        >
          <span>
            <ShowMore.Label.Counter count={count} />
          </span>
        </InformationPopover.Popover>
      )}
    </Flex>
  )
}
